// @core/api/endpoints/booking/get_resource_stats.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ResourceStatsResponse,
} from '../../../types/booking';

const BASE_PATH = '/booking';

/**
 * Get resource stats
 * Returns booking statistics for a resource: occupancy rate, revenue, cancellation and no-show rates, average rating.
 */
export async function GetResourceStats(
  resource_id: string,
  params?: {
    period_from?: string | number | boolean;
    period_to?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<ResourceStatsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/resources/:resource_id/stats`;
  requestPath = requestPath.replace(':resource_id', encodeURIComponent(resource_id));
  const requestOptions = options;
  return client.get<ResourceStatsResponse>(requestPath, { ...requestOptions, params });
}
